import { Stack, Typography } from '@mui/material';
import { LocationOn } from '@mui/icons-material';

export default function LocationsTitle() {
  return (
    <Stack direction="row" spacing={2} sx={{
      alignItems: "center"
    }}>
      <LocationOn />
      <Typography variant="h5" sx={{ flex: 1 }}>
        Location
      </Typography>
    </Stack>
  );
}